// @ts-nocheck
import _ from 'lodash';
import moment from 'moment-timezone';

export const formatDate = (date: string): string => {
  return moment.tz(date, 'America/Georgia').format('MM-DD-YYYY');
};
